import React from 'react';
import { theme, Typography, Flex } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import { CustomTooltip } from '~components/Tooltip';

type GatedRow = 'aiInsights';

type LegendFeature = {
  label: string;
  tooltip?: string;
  visibleWhen?: GatedRow;
};

const FEATURES: LegendFeature[] = [
  { label: 'Renders per month' },
  { label: 'Extra renders' },
  { label: 'Cache expiration (Account)' },
  { label: 'Cache expiration (URL)' },
  { label: 'Sitemap revisit' },
  { label: 'Data retention' },
  { label: 'Location-specific rendering' },
  { label: 'Audit log' },
  { label: 'Support channels' },
  { label: 'SLA' },
  { label: 'Priority support' },
  { label: 'Insights' },
  { label: 'AI Insights', tooltip: 'AI crawler monitoring + on-demand diagnostics', visibleWhen: 'aiInsights' },
  {
    label: 'Search Performance',
    tooltip: 'Google Search Console visibility report for the domains you sync with Prerender',
  },
];

type Props = {
  showAiInsights?: boolean;
};

function PricingPlanCardLegend({ showAiInsights = false }: Props) {
  const { token } = theme.useToken();

  const isRowVisible: Record<GatedRow, boolean> = {
    aiInsights: showAiInsights,
  };
  const visibleFeatures = FEATURES.filter((feature) => !feature.visibleWhen || isRowVisible[feature.visibleWhen]);

  return (
    <div
      style={{
        padding: token.padding,
        border: `1px solid ${token.colorBorder}`,
        borderRadius: token.borderRadius,
        backgroundColor: '#E3E3E3',
        maxWidth: 182 + 32,
      }}
    >
      <div style={{ marginBottom: 90 }}>
        <Typography.Text type="secondary">Compare plans to see what’s included</Typography.Text>
      </div>
      <Flex vertical gap="middle">
        {visibleFeatures.map(({ label, tooltip }) => (
          <Flex key={label} align="center" gap={token.marginXXS} style={{ whiteSpace: 'nowrap' }}>
            <Typography.Text type="secondary">{label}</Typography.Text>
            {tooltip && (
              <CustomTooltip placement="top" message={tooltip}>
                <InfoCircleOutlined style={{ color: token.colorTextSecondary, cursor: 'pointer' }} />
              </CustomTooltip>
            )}
          </Flex>
        ))}
      </Flex>
    </div>
  );
}

export default PricingPlanCardLegend;
